import React from "react";
import "./styles.scss";
import CurrencyInput from "react-currency-input-field";

const Input = (props) => {
  const {
    className,
    label,
    onChange,
    inputClassName = "",
    name,
    defaultValue,
    errorMessage,
    isCurrencyInput = false,
    ...rest
  } = props;
  const handleOnChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
    return null;
  };
  const handleCurrencyChange = (value) => {
    if (onChange) {
      onChange(value);
    }
    return null;
  };

  return (
    <label
      className={`input ${errorMessage ?? "input--error"}  ${className ?? ""}`}
    >
      {label && <span className="input__label">{label} </span>}
      {isCurrencyInput ? (
        <CurrencyInput
          intlConfig={{ locale: "nl-NL", currency: 'EUR' }}
          {...rest}
          className={`input__value ${inputClassName ?? ""}`}
          decimalsLimit={2}
          defaultValue={defaultValue}
          onValueChange={(value, name) => handleCurrencyChange(value)}
        />
      ) : (
        <input
          className={`input__value ${inputClassName}`}
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          defaultValue={defaultValue}
          {...rest}
          onChange={(e) => {
            handleOnChange(e);
          }}
        />
      )}
      {errorMessage && <span className="error">{errorMessage}</span>}
    </label>
  );
};

export default Input;
